import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSearchSiteModule } from './app-search-site/app-search-site.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    AppSearchSiteModule
  ],
  exports: [AppSearchSiteModule]
})
export class TvModule { }
